







import { ChartData, ChartOptions } from 'chart.js';
import { Bar, mixins } from 'vue-chartjs';
import { Component, Vue, Prop } from 'vue-property-decorator';

const { reactiveProp } = mixins;

@Component({
  mixins: [reactiveProp],
  extends: Bar,
})
export default class SubscriptionChartBarComponent extends Vue<Bar> {
  @Prop()
  private options: ChartOptions;

  private chartData: ChartData;

  constructor() {
    super();
  }

  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
}
